<template>
    <div class="school-admin-manage">
        <SuperAdminHeader>
<!--            <template v-slot:title v-if="userProfile.schools">{{ userProfile.schools[0].nameRu }}</template>-->
            <template v-slot:userName v-if="userProfile.user">{{ userProfile.user.firstName }} {{ userProfile.user.lastName }}</template>
            <template v-slot:roleName>{{ $t('ROLE_ADMIN') }}</template>
        </SuperAdminHeader>
        <div class="school-admin-manage__container">
            <div class="manage-mob">
                <v-app-bar-nav-icon class="mn-btn" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-navigation-drawer v-model="drawer" absolute left temporary width="100px">
                    <Sidebar :role="'schoolAdmin'"/>
                </v-navigation-drawer>
            </div>
            <div class="manage-des"><Sidebar :role="'schoolAdmin'"/></div>
            <div class="school-admin-manage__body" id="school-admin-manage__body">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import SuperAdminHeader from '@/components/navigations/sidebars/SuperAdminHeader'
import Sidebar from '@/components/navigations/sidebars/Sidebar'

export default {
  name: 'SchoolAdminManage',
  components: { Sidebar, SuperAdminHeader },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    }
  },
  data: () => ({
    drawer: false,
    group: null
  }),

  watch: {
    group () {
      this.drawer = false
    }
  }
}
</script>

<style lang="scss">
    .school-admin-manage {
        background: #f8f8fb;

        &__container {
            display: flex;
            /*height: calc(100vh - 76px);*/
        }
        &__body {
            /*width: calc(100% - 96px);*/
            /*overflow-y: auto;*/
            width: calc(100% - 100px);
            margin-left: 100px;
            min-height: 88vh;
            /*overflow-x: auto;*/
        }
        .super-admin-sidebar {
            /**/
            position: fixed;
            top: 0;
            height: 100vh;
        }
    }
    .manage-mob{
        display: none;
    }
    .manage-des{
        display: flex;
    }
    @media (max-width: 420px) {
        .mn-btn{
            position: absolute;
            top: 0;
            padding: 35px 30px;
        }
        .super-admin-header{
            &__info{
                margin-left: 100px;
            }
        }
        .manage-mob{
            display: flex;
            flex-direction: column;
        }
        .manage-des{
            display: none;
        }

        .school-admin-manage {
            background: #f8f8fb;

            &__container {
                display: flex;
                /*height: calc(100vh - 76px);*/
            }
            &__body {
                /*width: calc(100% - 96px);*/
                /*overflow-y: auto;*/
                width: 100%;
                margin-left: 0;
                //min-height: 88vh;
                /*overflow-x: auto;*/
            }
            .super-admin-sidebar {
                /**/
                position: absolute;
                top: 0;
                height: 100vh;
                z-index: 10000;
            }
        }

    }
</style>
